import React from 'react';

/**
 * Formats a number as Nepali Rupees currency.
 */
export const formatCurrency = (amount) =>
    new Intl.NumberFormat('en-NP', {
        style: 'currency',
        currency: 'NPR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amount || 0);

/**
 * Formats a number with commas.
 */
export const formatNumber = (num) =>
    new Intl.NumberFormat('en-US').format(num || 0);

/**
 * Converts a duration in seconds to a human-readable string.
 */
export const formatDuration = (seconds) => {
    if (!seconds) return '0s';
    if (seconds < 60) return `${Math.round(seconds)}s`;
    if (seconds < 3600) return `${Math.round(seconds / 60)}m ${Math.round(seconds % 60)}s`;
    return `${Math.round(seconds / 3600)}h ${Math.round((seconds % 3600) / 60)}m`;
};

/**
 * Formats a date string to YYYY-MM-DD (for API query params).
 */
export const toApiDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return d.toISOString().split('T')[0];
};

/**
 * Returns { from, to } date strings for common presets.
 */
export const getDateRange = (preset) => {
    const now = new Date();
    const to = toApiDate(now);

    switch (preset) {
        case '7d': {
            const from = new Date(now);
            from.setDate(from.getDate() - 6);
            return { from: toApiDate(from), to };
        }
        case '30d': {
            const from = new Date(now);
            from.setDate(from.getDate() - 29);
            return { from: toApiDate(from), to };
        }
        case 'thisMonth': {
            const from = new Date(now.getFullYear(), now.getMonth(), 1);
            return { from: toApiDate(from), to };
        }
        case 'all':
        default:
            return { from: '', to: '' };
    }
};
